export const UPDATE_VIEWPORT = 'UPDATE_VIEWPORT'
export const UPDATE_VIEWPORT_LOADING = 'UPDATE_VIEWPORT_LOADING'
export const UPDATE_VIEWPORT_SUCCESS = 'UPDATE_VIEWPORT_SUCCESS'
export const UPDATE_VIEWPORT_ERROR = 'UPDATE_VIEWPORT_ERROR'
